import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numIssueShipped: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart.tooltip.num-issue-shipped',
		defaultMessage: '{numIssues} {numIssues, plural, one {issue} other {issues}} shipped',
		description:
			'Display how many number of issues are shipped during the period when the mouse is hovered on a bar in the bar chart.',
	},
	weekStartDate: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart.tooltip.week-start-date',
		defaultMessage: 'Week of {date}',
		description:
			'Display how many number of issues are shipped during the period when the mouse is hovered on a bar in the bar chart.',
	},
	numIssueShippedIssueTerminologyRefreshM4: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart.tooltip.num-issue-shipped-issue-terminology-refresh-m4',
		defaultMessage: '{numIssues} {numIssues, plural, one {work item} other {work items}} shipped',
		description:
			'Display how many number of issues are shipped during the period when the mouse is hovered on a bar in the bar chart.',
	},
});
